export default __webpack_public_path__ + "static/HZH_GVR_run-b0af06c0e61812b2c631cf33e6e0d7b0.png";